<ng-container *ngIf="showCustomerRequests; else singleList">
  <lib-gung-tabset>
    <lib-gung-tab title="{{ 'USER_REQUESTS' | translate }}" id="user-requests">
      <ng-template libGungTabContent>
        <div class="row">
          <div class="col-12">
            <lib-filter-list [configService]="accountRequestListConfigService"></lib-filter-list>
          </div>
        </div>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab title="{{ 'CUSTOMER_REQUESTS' | translate }}" id="customer-requests">
      <ng-template libGungTabContent>
        <div class="row">
          <div class="col-12">
            <lib-filter-list [configService]="customerRequestListConfigService"></lib-filter-list>
          </div>
        </div>
      </ng-template>
    </lib-gung-tab>
  </lib-gung-tabset>
</ng-container>
<ng-template #singleList>
  <div class="row">
    <div class="col-12">
      <lib-filter-list [configService]="accountRequestListConfigService"></lib-filter-list>
    </div>
  </div>
</ng-template>
